import { Application, Controller } from "stimulus"

export default class AddPlaceSuggestedPlacesController extends Controller {
  
  static targets = ["suggestedPlace", "breadcrumbPlace"]

  suggestedPlacesObserver = this.suggestedPlacesObserver();
  navigationType = String(window.performance.getEntriesByType("navigation")[0].type)
  loadImages = this.navigationType == "reload" || this.navigationType== "back_forward" || !this.hasBreadcrumbPlaceTarget;

  connect() {
    this.loadImages ? this.appendSuggestedPlacesImages() : this.suggestedPlacesObserver.observe(this.breadcrumbPlaceTarget);
  }

  suggestedPlacesObserver() {
    return new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0.2) {
          this.appendSuggestedPlacesImages();
          this.suggestedPlacesObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.25 });
  }

  appendSuggestedPlacesImages() {
    this.suggestedPlaceTargets.forEach(suggestedPlace => {
      const imgStyleUrl = `url(${suggestedPlace.dataset.addPlaceSuggestedPlacesImageUrl})`
      suggestedPlace.style.backgroundImage = imgStyleUrl;
    });
  }

}

const application = Application.start()
application.register("add-place-suggested-places", AddPlaceSuggestedPlacesController)
